const state = {
    user_info:null,
};

const mutations={
    setUserInfo(state,data){
        state.user_info = data;
    }
};

const actions={

};

export default {
    namespaced:true,//用于在全局引用此文件里的方法时标识这一个的文件名
    state,
    mutations,
    actions,
}
